import type {PromotionCycle} from '../../types';

import {dateToReadableDate} from '@date-picker';
import {Divider} from '@ds/components';

import AvailableDiscountCard from './components/AvailableDiscountCard/AvailableDiscountCard';

type AvailableDiscountsProps = {
  cycles: PromotionCycle[];
};

const AvailableDiscounts: React.FC<AvailableDiscountsProps> = ({cycles}) => {
  return cycles.map((cycle) => (
    <div key={cycle.cycle_id}>
      <div className="p-4">
        <AvailableDiscountCard
          cycle={cycle}
          description={`تا ${dateToReadableDate({
            date: cycle.deal_end_date,
            month: true,
            day: true
          })} فرصت دارید در این دوره از تخفیف شرکت کنید`}
        />
      </div>
      <Divider className="bg-gray-02" size={8} />
    </div>
  ));
};

export default AvailableDiscounts;
